// extracted by mini-css-extract-plugin
export default {"draft-image":"Draft_draft-image__hjEcZ","close-icon":"Draft_close-icon__dlZXb","popup":"Draft_popup__V0g1f"};